exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-32f50f19]{display:block}.item[data-v-32f50f19]:hover{color:#598ebd}.item__arrow[data-v-32f50f19]{height:100%;flex:0 0 auto;color:#d5d5d8;transition:color .2s ease-out}.item:hover .item__arrow[data-v-32f50f19]{color:#598ebd}", ""]);

// exports
